module.exports = __webpack_public_path__ + "static/img/shipped.1f673a4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/shipped.svg
// module id = /klL
// module chunks = 1